import React, {useState, useEffect} from 'react'
import {useAuth} from '../context/AuthContext'
import {useLocation} from 'react-router-dom'
import apiClient from '../api/apiClient'

export default function TeacherExamGradingPage(){
    const {user} = useAuth()
    const {state} = useLocation()
    const testGroupID = state.testGroupID

    const [testGroup, setTestGroup] = useState(null)
    const [studentList, setStudentList] = useState([])
    const [gradeList, setGradeList] = useState([])

    async function fetchTestGroup(){
        try{
            const result = await apiClient.get('/api/testgroup/gettestgroup', {
                params: {testGroupID: testGroupID}
            })
            setTestGroup(result.data)
        }catch(e){
            console.log("errro in get test group")
            console.log(e)
        }
    }

    async function fetchStudentList(){
        console.log("fetching students for testgroup "+ testGroupID)
        try{
            const result = await apiClient.get('/api/testgroup/getstudentsintestgroup',
                {params: {testGroupID: testGroupID || null}}
            )
            const theStudents = result.data.map(student =>
                student.underviser_karakter === null ?
                ({...student,
                    underviser_karakter: {
                        laese1_grade: '',
                        laese1_comment : '',
                        laese2_grade: '',
                        laese2_comment : '',
                        skrive_grade: '',
                        skrive_comment: ''
                    }
                 })
                :
                student
            )
            //setStudentList(result.data)
            setStudentList(theStudents)
        }catch(e){
            console.log(" error in getting students for group")
            console.log(e)
        }      
    }

    useEffect(()=>{
        fetchTestGroup()
        fetchStudentList()
    }, [])

    async function handleChange(e, student_id){
        e.preventDefault()
        const {name, value} = e.target

        console.log(`vi fik ${name}, ${value}, ${student_id}`)

        //console.log(studentList)
        const currentStudent = studentList.find(s => s.id === student_id)
        
        const newStudent = {...currentStudent, 
                            underviser_karakter: {...currentStudent.underviser_karakter, [name]: value}
        }   
        setStudentList(studentList.map(s => s.id === student_id ? newStudent : s))
      
        try{
            await apiClient.post('/api/testgroup/updateteachergrades', {student: newStudent})
        }catch(e){
            console.log("fejl i upgrade grades for teacher")
            console.log(e)
        }
    }

    async function commitGrades(){
        console.log("commiting grades")
        console.log(`grade commit ${testGroup.gradecommit_underviser}`)
        try{
            await apiClient.post('/api/testgroup/commitgrades', {testGroupID: testGroupID, type: 'teachercommit'})
        }catch(e){
            console.log("fejl ved commit af lærer")
            console.log(e)
        }
    }
 
    const rows =2
    const cols = 30
    return(
    <div className="panel-container">
        <div className="panel">
            <span>
                <b>Testgruppe: {testGroup?.navn}</b>
            </span>
            {studentList.length === 0 ? (
                <p className="drop-zone-hint">Ingen kursister i prøvegruppe</p>
            ): (
                <div>
                    <div>
                        {testGroup?.gradecommit_underviser ? 
                            (
                                <h2>Prøvekarakter låste</h2>
                            ):
                            (
                                <button onClick={commitGrades}>Afslut karaktergivning</button>
                            )
                        }
                    </div>
                <table className="censor-table">
                    <thead>
                        <th style={{width: '5%'}}>Kursist ID</th>
                        <th style={{width: '15%'}}>Fornavn(e)</th>
                        <th style={{width: '15%'}}>Efternavn</th>
                        <th style={{width: '65%'}}>Karakter</th>
                    </thead>
                    <tbody>
                        {studentList.map(student =>                                 
                                (<tr key={student.id}>
                                    <td>{student.id}</td>
                                    <td>{student.fornavne}</td>
                                    <td>{student.efternavn}</td>
                                    <td>
                                        <fieldset disabled={testGroup?.gradecommit_underviser} style={{border: 'none', padding: 0, margin: 0}}>
                                        <table>
                                            <tr><td><label>Læseprøve 1 </label>
                                            <input type="text" defaultValue="0" name="laese1_grade"
                                             value={student.underviser_karakter.laese1_grade}
                                            onChange={(e)=>handleChange(e,student.id)}/></td>
                                            <td><label>Kommentar: </label>
                                            <textarea rows={rows} cols={cols} name="laese1_comment"
                                             value={student.underviser_karakter.laese1_comment}
                                            onChange={(e)=>handleChange(e,student.id)}/></td></tr>
                                            <tr><td><label>Læseprøve 2 </label>
                                            <input type="text" defaultValue="0" name="laese2_grade"
                                             value={student.underviser_karakter.laese2_grade}
                                            onChange={(e)=>handleChange(e,student.id)}/></td>
                                            <td><label>Kommentar: </label>
                                            <textarea rows={rows} cols={cols} name="laese2_comment"
                                             value={student.underviser_karakter.laese2_comment}
                                            onChange={(e)=>handleChange(e,student.id)}/></td></tr>
                                            <tr><td><label>Skriftlig prøve </label>
                                            <input type="text" defaultValue="0" name="skrive_grade"
                                             value={student.underviser_karakter.skrive_grade}
                                            onChange={(e)=>handleChange(e,student.id)}/></td>
                                            <td><label>Kommentar: </label>
                                            <textarea rows={rows} cols={cols} name="skrive_comment" 
                                             value={student.underviser_karakter.skrive_comment}
                                            onChange={(e)=>handleChange(e,student.id)}/></td></tr>
                                        </table>
                                        </fieldset>
                                    </td>
                                </tr>)                            
                        ) 
                        }
                    </tbody>
                </table>
                </div>
            )}
        </div>
    </div>
    )
}
